import "./Home.module.css";
import PrimaryNavigation from "@/reusable_sections/Header";
import QuickQuoteForm from "./sections/QuickQuoteForm";
import Hero from "./sections/Hero";
import HeroSection from "./sections/HeroSection";
import Testimonials from "./sections/Testimonials";
import TheVisionaryBehindTheBrand from "./sections/TheVisionaryBehindTheBrand";
import ElevateYourStrategy from "./sections/ElevateYourStrategy";
import TheAudioExperience from "./sections/TheAudioExperience";
import TheUnfilteredJourney from "./sections/TheUnfilteredJourney";
import WarmMinimalist from "./sections/WarmMinimalist";
import OptimaHero from "./sections/OptimaHero";
import ServiceHighlight from "./sections/ServiceHighlight";
import ServiceHighlights from "./sections/ServiceHighlights";
import BrandFooter from "@/reusable_sections/Footer";
import Information from "./sections/Information";
import InformationLayout from "./sections/InformationLayout";
export default function HomePage() {
  return <div>
      <PrimaryNavigation />
      <ServiceHighlights />
      <QuickQuoteForm />
      <OptimaHero />
      <Hero />
      <ServiceHighlight />
      <Information />
      <Testimonials />
      <HeroSection />
      <InformationLayout />
      <TheVisionaryBehindTheBrand />
      <ElevateYourStrategy />
      <TheAudioExperience />
      <TheUnfilteredJourney />
      <WarmMinimalist />
      <BrandFooter />
    </div>;
}